import React from "react";
import {
  visa,
  jcb,
  mastercard,
  paypal,
  fb,
  ig,
  youtube,
  twitter,
  tiktok,
} from "../../assets/svg";
import { Link } from "react-router-dom";
import { appstoreicon, googleplayicon, icon } from "../../assets";

const links = [
  { text: "Privacy Policy", url: "/privacy-policy" },
  // { text: "Manage Cookies", url: "/cookies" },
  // { text: "Terms & Conditions", url: "/terms" },
  // { text: "Sitemap", url: "/sitemap" },
];
const footerData = [
  {
    title: "Buy on WristLink",
    id: "a11y-footer-buy-nav",
    links: [
      // { text: "WristLink Buyer Protection", href: "/about-us.htm" },
      // {
      //   text: "Payment via an escrow account",
      //   href: "/about-us.htm#payment-via-escrow-service",
      // },
      {
        text: "Trusted Dealers",
        href: "/supplier",
      },
      // { text: "Easy Returns", href: "/about-us.htm#returns" },
    ],
  },
  {
    title: "Sell on WristLink",
    id: "a11y-footer-sell-nav",
    links: [
      // { text: "Selling Watches as a Private Seller", href: "/offer/index.htm" },
      { text: "List To Sell", href: "/user/create-listing" },
      // { text: "Free Watch Valuation", href: "#" },
      // { text: "Advice for private sellers", href: "/info/guide.htm" },
    ],
  },
  {
    title: "About WristLink",
    id: "a11y-footer-about-WristLink-nav",
    links: [
      { text: "About us", href: "/about-us" },
      // { text: "Jobs", href: "/jobs" },
      // { text: "Press", href: "https://about.chrono24.com/en/press/" },
      { text: "Contact", href: "/contact-us" },
    ],
  },
  {
    title: "Personalized Support",
    id: "a11y-footer-support-nav",
    links: [
      { text: "+971 50 22 77747", icon: "phone" },
      { text: "info@wristlink.app", icon: "email" },
      { text: "Frequently Asked Questions", href: "/faqs" },
    ],
  },
  // {
  //   title: "WristLink Apps",
  //   id: "a11y-footer-apps-nav",
  //   content: (
  //     <div className="flex gap-2 items-center">
  //       <img
  //         src="https://static.chrono24.com/images/default/footer-app-qr-code.svg"
  //         alt="QR Code"
  //         height="90"
  //         className="rounded-md h-[90px] w-[90px]"
  //       />
  //       <div>
  //         <Link
  //           className="block mb-2"
  //           to="https://discover.chrono24.com/VuxF?af_xp=custom&pid=WristLink&c=footer&af_dp=WristLink-app://&utm_source=WristLink&utm_medium=onsite&utm_campaign=footer"
  //           target="_blank"
  //           aria-label="To the App Store"
  //         >
  //           <img
  //             src={appstoreicon}
  //             alt="App Store"
  //             className="h-[40px] w-[135px]"
  //           />
  //         </Link>
  //         <Link
  //           to="https://discover.chrono24.com/VuxF?af_web_dp=https://play.google.com/store/apps/details?id=com.WristLink.mobile&af_xp=custom&pid=WristLink&c=footer&af_dp=WristLink-app://&utm_source=WristLink&utm_medium=onsite&utm_campaign=footer"
  //           target="_blank"
  //           aria-label="To Google Play"
  //         >
  //           <img
  //             src={googleplayicon}
  //             alt="Google Play"
  //             className="h-[40px] w-[135px]"
  //           />
  //         </Link>
  //       </div>
  //     </div>
  //   ),
  // },
  {
    title: "Payment Methods",
    id: "a11y-footer-payment-methods-nav",
    content: (
      <div className="flex flex-wrap space-x-3">
        <img src={visa} alt="Visa" className="w-8 h-8" />
        <img src={mastercard} alt="Mastercard" className="w-8 h-8" />
        <img src={paypal} alt="PayPal" className="w-8 h-8" />
        <img src={jcb} alt="JCB" className="w-8 h-8" />
      </div>
    ),
  },
];
const social = [
  {
    icon: fb,
    url: "https://www.facebook.com/profile.php?id=61550855387412",
  },
  {
    icon: ig,
    url: "https://www.instagram.com/wristwurx",
  },
];
const Footer = ({ maxWidth = 1200 }) => {
  return (
    <footer className="bg-secondary text-white w-full ">
      <div
        style={{ maxWidth: maxWidth }}
        className=" mx-auto  lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12"
      >
        {/* PREVIOUS GRID_COLS_3 */}
        <div className="grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 lg:gap-16 md:gap-12 sm:gap-8">
          {footerData?.map((section, index) => (
            <div key={index} className="space-y-2">
              <h2 id={section?.id} className="text-[16px] font-semibold mb-3">
                {section?.title}
              </h2>
              <nav aria-labelledby={section?.id}>
                {section?.links ? (
                  <ul className="list-none space-y-1">
                    {section?.links?.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        {link?.href ? (
                          <Link
                            to={link?.href}
                            className="text-white hover:underline text-[14px]"
                          >
                            {link?.text}
                          </Link>
                        ) : link?.type === "button" ? (
                          <button
                            className="text-white hover:underline text-[14px]"
                            type="button"
                          >
                            {link?.text}
                          </button>
                        ) : (
                          <span className="text-white flex items-center space-x-1 text-[14px]">
                            <i className={`i-${link?.icon}`}></i>
                            <span>{link?.text}</span>
                          </span>
                        )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div>{section?.content}</div>
                )}
              </nav>
            </div>
          ))}
        </div>

        <div className=" mx-auto flex lg:flex-row md:flex-row sm:flex-col gap-8  justify-between lg:items-center md:items-center sm:items-start mt-12 pt-6 border-t border-t-primary">
          {/* Left Links */}
          <div className="flex lg:flex-row md:flex-row sm:flex-col gap-2 text-sm">
            {links.map((link, index) => (
              <Link key={index} to={link.url} className="hover:text-white">
                {link.text}
              </Link>
            ))}
          </div>

          {/* Social Media Icons */}
          <div className="flex space-x-4 ">
            {social?.map((plt, index) => (
              <Link
                key={index}
                to={plt?.url}
                target="_blank"
                className="hover:text-white"
              >
                <img
                  src={plt?.icon}
                  className="h-8 w-8 bg-primary rounded-full p-1"
                  alt=""
                />
              </Link>
            ))}
            <Link
              target="_blank"
              className="hover:text-white rounded-full bg-[#D2D1CA] h-[30px] w-[30px] flex justify-center items-center"
              to="https://uk.linkedin.com/company/wristwurx"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="black"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-[#D2D1CA]"
              >
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z" />
                <rect x="2" y="9" width="4" height="12" />
                <circle cx="4" cy="4" r="2" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
